import anime from 'animejs';
import { isEditMode } from './helpers';
import movingImage from './moving-image';
import debounceObservation from './debounce-observation';

const CLASS = 'show';

function childrenForEach(ch, cb) {
  for (let i = 0; i < ch.length; i++) {
    cb(ch[i], i);
  }
}

function animateLine(line, tl, position) {
  line.classList.add(CLASS);
  childrenForEach(line.children, (el, i) => setTimeout(() => {
    el.classList.add(CLASS);
  }, position + i * 400 / Math.min(line.children.length, 20)));
}

function splitLine(line, splitter = '') {
  const letters = line.textContent
    .replace(/\s/g, ' ')
    .split(splitter);
  line.textContent = '';
  letters.forEach((char) => {
    const span = document.createElement('span');
    line.appendChild(span);
    span.textContent = char;
  });
  line.classList.add('letters');
  line.classList.remove(CLASS);
  childrenForEach(line.children, el => el.classList.remove(CLASS));
}

function splitWords(el) {
  const words = el.textContent
    .trim()
    .replace(/\s/g, ' ')
    .split(' ');
  if (words.length === 1 && /[a-z][A-Z]/.test(words[0])) { // example case: 8WaysMediaIsBest
    // console.warn('something wrong with words', { el, words });
    return; // too long word error fix
  }
  el.textContent = '';
  words.forEach((word) => {
    const span = document.createElement('span');
    span.classList.add('word');
    el.appendChild(span);
    span.textContent = word;
  });
}

export function init(el) {
  const { linesSelector } = el.dataset;
  // const splitter = (el.dataset.stagger === 'letters' && !window.isMobile.any) ? '' : 'gnewkghn';
  const splitter = 'gnewkghn';
  if (linesSelector) {
    if (linesSelector === '.word') {
      splitWords(el);
    }
    const lines = el.querySelectorAll(linesSelector);
    lines.forEach(line => splitLine(line, splitter));
  } else {
    splitLine(el, splitter);
  }
}

export function reset(el) {
  const { linesSelector } = el.dataset;
  if (linesSelector) {
    const lines = el.querySelectorAll(linesSelector);
    lines.forEach((line) => {
      line.classList.remove(CLASS);
      childrenForEach(line.children, c => c.classList.remove(CLASS));
    });
  } else {
    el.classList.remove(CLASS);
    childrenForEach(el.children, c => c.classList.remove(CLASS));
  }
}

export function reveal(el) {
  const { linesSelector, staggerInterval = 0 } = el.dataset;
  if (linesSelector) {
    const lines = el.querySelectorAll(linesSelector);
    const tl = anime.timeline(/* { autoplay: false } */);
    lines.forEach((line, i) => {
      animateLine(line, tl, i * staggerInterval);
    });
  } else {
    animateLine(el);
  }
}

export function dispose(el) {
  const { linesSelector } = el.dataset;
  if (linesSelector) {
    const lines = el.querySelectorAll(linesSelector);
    lines.forEach(line => line.innerHTML = line.textContent);
  } else {
    el.innerHTML = el.textContent;
  }
}

let observer;
const debounceObservation2 = debounceObservation((el) => {
  // if ('isIntersecting' in el.dataset) {
  reveal(el);
  if (el.dataset.noUnobserve === undefined) {
    observer.unobserve(el);
  }
  // }
}, (el) => {
  if ('noUnobserve' in el.dataset) {
    reset(el);
  }
});

observer = new IntersectionObserver((entries) => {
  entries.forEach(debounceObservation2);
}, { threshold: 0, rootMargin: '0px 0px -80px' });

export default function (container) {
  if (window.isMobile.any || isEditMode()) return;
  observer.disconnect();

  // hack for editable HTML
  document.querySelectorAll('.cover h1, .cover h2, .cover h3').forEach((el) => {
    if (!('stagger' in el.dataset)) {
      el.dataset.stagger = 'lines';
      el.dataset.linesSelector = '.word';
    }
  });

  container.querySelectorAll('[data-stagger]').forEach((el) => {
    init(el);
    if (movingImage.isAnimating()) {
      observer.observe(el);
    } else {
      anime.set(el, { visibility: 'hidden' });
      setTimeout(() => {
        anime.set(el, { visibility: '' });
        observer.observe(el);
      }, 300);
    }
  });
}
